import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const resetScrollPosition = (element: Element) => {
  if (element instanceof HTMLElement) {
    element.scrollTop = 0;
    element.scrollLeft = 0;
  }
};

/** Keep route transitions from inheriting a previous screen's scroll offset. */
const RouteScrollReset = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.querySelectorAll("[data-route-scroll-container]").forEach(resetScrollPosition);
  }, [pathname]);

  return null;
};

export default RouteScrollReset;
